import React from 'react';
import SegmentMonetizationCard from '../monetization/SegmentMonetizationCard';
import SegmentReachCard from '../monetization/SegmentReachCard';
import CampaignOpportunityCard from '../monetization/CampaignOpportunityCard';
import SlotPerformanceCard from '../monetization/SlotPerformanceCard';
import AdSurfacePreviewCard from '../monetization/AdSurfacePreviewCard';

export default function MonetizationGuardedSection({ enabled = false }) {
  if (!enabled) return null;

  return (
    <section className="space-y-3">
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-sm font-black text-slate-900 dark:text-white">Monetization (Guarded)</h3>
        <span className="text-xs text-slate-500 dark:text-slate-400">Aşamalı aktivasyon</span>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        <SegmentMonetizationCard />
        <SegmentReachCard />
        <CampaignOpportunityCard />
        <SlotPerformanceCard />
        <AdSurfacePreviewCard />
      </div>
    </section>
  );
}
